export enum ContractorDocumentType {
    FORM_W9 = "FORM_W9",
    FORM_W_8BEN = "FORM_W_8BEN",
    FORM_W_8BEN_E = "FORM_W_8BEN_E"
}
